var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7092 8.47465H3.07812V6.91873C3.07812 5.91677 3.89036 5.10449 4.89236 5.10449H16.895C17.897 5.10449 18.7093 5.91673 18.7093 6.91873V8.47465H18.7092Z",
    stroke: "#111111",
    strokeWidth: 1.62857,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2818 5.10387H7.50586V3.89837C7.50586 2.75768 8.43057 1.83301 9.57122 1.83301H12.2165C13.3572 1.83301 14.2819 2.75772 14.2819 3.89837V5.10387H14.2818Z",
    stroke: "#111111",
    strokeWidth: 1.62857,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01953 12.2021V16.7419",
    stroke: "#111111",
    strokeWidth: 1.62857,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7686 12.2021V16.7419",
    stroke: "#111111",
    strokeWidth: 1.62857,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9391 18.8246L17.6118 8.47461H4.1748L4.84525 18.7941C4.92885 20.0812 5.9972 21.0824 7.28698 21.0824H14.4996C15.7791 21.0824 16.8408 20.097 16.9391 18.8246Z",
    stroke: "#111111",
    strokeWidth: 1.62857,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteai);
export default __webpack_public_path__ + "static/media/deleteai.ed68ee4fe1b42e160ce9dd5587a9e359.svg";
export { ForwardRef as ReactComponent };